// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Label = require("../common/Components/Label.bs.js");
var Tooltip = require("../../reason/common/Tooltip.bs.js");
var DateFns = require("date-fns");
var Caml_option = require("rescript/lib/js/caml_option.js");
var CalendarDate = require("../../reason/common/types/CalendarDate.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
var PropertyMlsLabel_propertyV5_graphql = require("../../__generated__/PropertyMlsLabel_propertyV5_graphql.bs.js");

var convertFragment = PropertyMlsLabel_propertyV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyMlsLabel_propertyV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyMlsLabel_propertyV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyMlsLabel_propertyV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyMlsLabel_propertyV5_graphql.node, convertFragment, fRef);
}

var PropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyMlsLabel(props) {
  var match = use(props.property);
  var mlsPlan = match.mlsPlan;
  var activeOnMlsSince = match.activeOnMlsSince;
  var match$1;
  if (activeOnMlsSince !== undefined) {
    match$1 = [
      JsxRuntime.jsx(Label.Neutral.make, {
            text: "On MLS"
          }),
      "Went active in the MLS on " + DateFns.format(CalendarDate.toLocalDate(Caml_option.valFromOption(activeOnMlsSince)), "MMM d")
    ];
  } else {
    switch (mlsPlan.__typename) {
      case "ListOnMlsAsActive" :
          match$1 = [
            JsxRuntime.jsx(Label.Neutral.make, {
                  text: "OFF-MLS till " + DateFns.format(CalendarDate.toLocalDate(mlsPlan.onMlsAt), "MMM d"),
                  variant: "light"
                }),
            undefined
          ];
          break;
      case "ListOnMlsAsComingSoon" :
          match$1 = [
            JsxRuntime.jsx(Label.Neutral.make, {
                  text: "MLS coming soon",
                  variant: "light"
                }),
            "Planned to go active in the MLS on " + DateFns.format(CalendarDate.toLocalDate(mlsPlan.activeOnMlsOn), "MMM d")
          ];
          break;
      case "NoMlsPlan" :
          match$1 = [
            JsxRuntime.jsx(Label.Neutral.make, {
                  text: "OFF-MLS",
                  variant: "light"
                }),
            undefined
          ];
          break;
      case "__unselected" :
          match$1 = UnselectedUnionMemberError.raise("Unselected MLS plan " + mlsPlan._0);
          break;
      
    }
  }
  var tooltip = match$1[1];
  var label = match$1[0];
  if (tooltip !== undefined) {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(Tooltip.make, {
                      label: tooltip,
                      children: JsxRuntime.jsx("span", {
                            children: label
                          })
                    }),
                className: "z-10 relative cursor-default"
              });
  } else {
    return JsxRuntime.jsx("div", {
                children: label
              });
  }
}

var make = PropertyMlsLabel;

exports.PropertyFragment = PropertyFragment;
exports.make = make;
/* Label Not a pure module */
